// client/src/utils/openProtected.js — open a stored file that needs the staff login.
//
// /uploads answers only a request carrying the Authorization header (and checks the
// file against the record it belongs to: middleware/uploadsAccess.js). A plain
// <a href="/uploads/..."> sends no header, so it opened a 401 page instead of the file
// (audit 2026-10). ProtectedLink keeps the link but fetches with the token and opens the
// file as a blob in a new tab.
import React from 'react';

export async function openProtected(url) {
    // Open the tab synchronously (inside the click) so a popup blocker allows it.
    const w = window.open('', '_blank');
    try {
        const r = await fetch(url, { headers: { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` } });
        if (!r.ok) {
            let m = `Could not open the file (${r.status}).`;
            try { m = (await r.json()).message || m; } catch (e) { /* not JSON */ }
            throw new Error(m);
        }
        const href = URL.createObjectURL(await r.blob());
        if (w) { w.opener = null; w.location.href = href; } else { window.open(href, '_blank', 'noopener'); }
    } catch (e) {
        if (w) w.close();
        window.alert(e.message);
    }
}

export const ProtectedLink = ({ href, children, className }) => (
    <a href={href} className={className} rel="noopener noreferrer"
       onClick={(e) => { e.preventDefault(); if (href) openProtected(href); }}>
        {children}
    </a>
);
